import React from 'react'

import { PageLayout, DailyStoreStatisticsChartWidget, DailyStoreStatisticsTop10Widget } from '../..'
import { USERS_WITHOUT_ACCESS } from '../../../constants/access'

class DailyStoreStatisticsPage extends React.Component {
  render() {
    const hasAccess = (ctx) => {
      if (USERS_WITHOUT_ACCESS.includes(+ctx.user.id_employee)) return false
      return true
    }

    return (
      <PageLayout hasAccess={hasAccess}>
        <div className="row">
          <div className="col-12 mb-2">
            <DailyStoreStatisticsChartWidget />
          </div>
          <div className="col-12 mb-2">
            <DailyStoreStatisticsTop10Widget />
          </div>
        </div>
      </PageLayout>
    )
  }
}

export default DailyStoreStatisticsPage
